import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Seo } from "@/components/seo/Seo";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.warn("404 — non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <>
      <Seo
        title="Page not found — Raise Sri Lanka"
        description="The page you were looking for doesn't exist. Explore our projects, news, or ways to give back."
        noIndex
      />
      <div className="container mx-auto flex min-h-[60vh] flex-col items-center justify-center px-4 py-20 text-center">
        <p className="text-sm font-semibold uppercase tracking-widest text-primary">404</p>
        <h1 className="mt-3 font-display text-4xl font-semibold md:text-5xl">Page not found</h1>
        <p className="mt-3 max-w-md text-muted-foreground">
          The page you were looking for doesn't exist or has moved. Try one of the links below.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Button asChild size="lg" className="rounded-full">
            <Link to="/">Back to home</Link>
          </Button>
          <Button asChild size="lg" variant="outline" className="rounded-full">
            <Link to="/projects">See projects</Link>
          </Button>
          <Button asChild size="lg" variant="outline" className="rounded-full">
            <Link to="/donate">Donate</Link>
          </Button>
        </div>
      </div>
    </>
  );
};

export default NotFound;
